<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.main
  width 100%
  height 100%
  // border: 1px solid green;
  background url('../../../../../assets/img/trp/right.png') no-repeat
  background-size 100% 100%
  .type
    width 20%
    float left
    text-align center
    color #FFF
    height 30px
  .active
    color blue
  .title
    height 55px
    font-size 18px
    font-family Microsoft YaHei
    font-weight bold
    color #fff
    line-height 45px
    margin-left 55px
  .swiper-wrap
    margin-top 5px
    height 153px
    // overflow: hidden;
    // border: 1px solid green;
    width 92%
  .list-item
    background #0B2574
    height 46px
    line-height 46px
    display flex
    font-size 16px
    margin-bottom 5px
    .item-rank
      width 10%
      color #fff
      text-align center
    .item1
      width 50%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      color white
      text-align left
    .item2
      width 20%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      color white
      text-align left
    .item3
      width 20%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      color white
      text-align left
  .list-item1
    color #00FEFB
    height 40px
    font-size 16px
    display flex
    width 92%
    margin 0 auto
    background url('../../../../../assets/img/trp/table.png') no-repeat
    background-size 100% 100%
    .item
      width 33%
      text-align left
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
    // .item-rank {
    // width: 10%;
    // text-align: left;
    // }
    .item1
      width 25%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .item2
      width 35%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
    .item3
      width 15%
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      line-height 40px
      text-align center
</style>

<template>
  <!-- <boxWrap :name="name" :min="true"> -->
  <!-- <div class="table"> -->

  <div class="main">
    <div class="title">区域农业投入品流通销售排行榜</div>
    <div v-for="(item,index) in list"
         :key="item"
         class="type"
         @click="changeType(item,index)"
         :class="{active:index==typeindex}">{{item}}</div>
    <div class="list-item1">
      <div class="item1">排名</div>
      <div class="item1">商品名</div>
      <div class="item2">登记证号</div>
      <div class="item3">数量</div>
    </div>
    <swiper :options="swiperOption"
            class="swiper-wrap"
            ref="mySwiper"
            v-if="tableData.length != 0">
      <swiper-slide v-for="(item, index) in tableData"
                    :key="index"
                    class="list-item">
        <i class="item-rank"
           :style="changeColor(index)">{{ index + 1 }}</i>
        <div class="item1">{{ item.name }}</div>
        <div class="item2">{{ item.orderNumber }}</div>
        <div class="item3">{{ item.lumpSum }}</div>
      </swiper-slide>
    </swiper>
  </div>
  <!-- </div> -->
  <!-- </boxWrap> -->
</template>

<script>
import boxWrap from '../common/boxWrap';
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: ['salesDataRealTime'],
  data () {
    return {
      name: '区域农业投入品流通销售排行榜',
      tableData: [],
      time: null,
      typeindex: 0,
      list: ['农药', '种子', '肥料', '兽药', '饲料'],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 100,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      },
      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"],
      data: {
        '农药': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好1' },
        { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好1' },
        { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好1' },
        { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好1' },
        { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好1' },
        { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好1' }],
        '种子': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好2' },
        { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好2' },
        { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好2' },
        { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好2' },
        { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好2' },
        { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好2' }],
        '肥料': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好3' },
        { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好3' },
        { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好3' },
        { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好3' },
        { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好3' },
        { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好3' }],
        '兽药': [],
        '饲料': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好4' },
        { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好4' },
        { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好4' },
        { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好4' },
        { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好4' },
        { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好4' }]
      }
    }
  },
  methods:
  {
    changeColor (index) {
      if (index <= 3) {
        return `color:${this.colorList[index]}`;
      } else {
        return `color:${this.colorList[3]}`;
      }
    },
    changeType (item, index) {
      console.log(index)

      this.typeindex = index
      this.tableData = this.data[item]
      if (this.data[item].length === 0) {
        setTimeout(() => {
          this.changeType(this.list[index + 1], index + 1)
        }, 1000);
        return
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted () {
    this.changeType(this.list[this.typeindex], this.typeindex)
    this.time = setInterval(() => {
      this.typeindex = this.typeindex + 1
      if (this.typeindex > 4) {
        this.typeindex = 0
      }
      this.changeType(this.list[this.typeindex], this.typeindex)
      this.$nextTick()
      console.log(this.typeindex)
    }, 3000);
  },
  beforeDestroy () {
    clearInterval(this.time);
    this.time = null;
  }
}

</script>


// WEBPACK FOOTER //
// index.vue?1953d6de